var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGradient = function SvgGradient(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1116,
    height: 500,
    viewBox: "0 0 1116 326",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#gradient_svg__a)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 102.36,
    cy: 326.656,
    rx: 102.36,
    ry: 326.656,
    transform: "matrix(.88254 -.47024 .73698 .67592 226.76 49.919)",
    fill: "url(#gradient_svg__b)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient_svg__b",
    x1: 186.189,
    y1: 142.11,
    x2: -70.591,
    y2: 222.575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2D177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#E2D177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE448A"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "gradient_svg__a",
    x: 0.635,
    y: -303.449,
    width: 1114.4,
    height: 1052.05,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 150,
    result: "effect1_foregroundBlur_11591_4347"
  })))));
};
export default SvgGradient;